import { belongsTo, Model } from 'miragejs';

export const ModelWithVersion = Model.extend({
  publishedBy: belongsTo('user'),
  modifiedBy: belongsTo('user'),
  createdBy: belongsTo('user'),
});
